import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "../../utils/cn";

export const Cover = ({ children, className }) => {
  const ref = useRef(null);
  const [beamPositions, setBeamPositions] = useState([]);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.clientHeight;
      const numberOfBeams = Math.floor(height / 10);
      const positions = Array.from(
        { length: numberOfBeams },
        (_, i) => (i + 1) * (height / (numberOfBeams + 1))
      );
      setBeamPositions(positions);
    }
  }, [ref.current]);

  return (
    <div
      ref={ref}
      className="relative inline-block bg-white/80 px-2 py-2 rounded-md"
    >
      {beamPositions.map((position, index) => (
        <Beam
          key={index}
          duration={Math.random() * 2 + 1}
          delay={Math.random() * 2 + 1}
          style={{
            top: `${position}px`,
          }}
        />
      ))}
      <motion.span
        animate={{
          scale: 0.9,
        }}
        className={cn(
          "text-gray-900 inline-block relative z-20 font-semibold",
          className
        )}
      >
        {children}
      </motion.span>
      <div className="absolute -right-[2px] -top-[2px] h-2 w-2 rounded-full bg-indigo-400/30" />
      <div className="absolute -bottom-[2px] -right-[2px] h-2 w-2 rounded-full bg-indigo-400/30" />
      <div className="absolute -left-[2px] -top-[2px] h-2 w-2 rounded-full bg-indigo-400/30" />
      <div className="absolute -bottom-[2px] -left-[2px] h-2 w-2 rounded-full bg-indigo-400/30" />
    </div>
  );
};

const Beam = ({ style, duration, delay }) => {
  return (
    <motion.div
      style={style}
      className="absolute h-[1px] w-full overflow-hidden"
    >
      <motion.div
        animate={{
          x: ["-100%", "200%"],
        }}
        transition={{
          duration: 0.8,
          repeat: Infinity,
          ease: "linear",
          delay: delay,
        }}
        className="h-full w-1/3 bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent"
      />
    </motion.div>
  );
}; 